import { Text } from '@querodelivery/uni-react';
import type { Motoboy } from '@/_features/motoboys/motoboy-list/types';
import styles from './linked-card.module.scss';

function LinkedCard({
  placesLinked,
}: {
  placesLinked: Motoboy['placesLinked'];
}) {
  if (!placesLinked) {
    return <p>Nenhuma vinculação encontrada</p>;
  }

  const placesName = Object.keys(placesLinked).map(key => {
    return placesLinked[key].placeName;
  });

  return (
    <div className={styles.container}>
      {placesName.map(place => (
        <div key={place}>
          <Text
            tone="supporting"
            variant="bodyMd"
            fontWeight="medium"
            lineHeight="sm"
            fontSize="sm"
            breakWord={false}
            truncate
          >
            {place}
          </Text>
        </div>
      ))}
    </div>
  );
}

export { LinkedCard };
